import {
  FaPersonRunning,
  FaBicycle,
  FaPersonSwimming,
  FaLayerGroup,
  FaWaveSquare,
  FaBed,
  FaMountain,
  FaDumbbell,
  FaClock,
  FaPersonSkiing,
  FaPersonWalking,
  FaQuestion,
  FaNoteSticky,
  FaPaperclip,
  FaCalendarDay,
  FaPlus,
  FaTrash,
} from "react-icons/fa6"
import React from "react"

const activities = [
  { name: "Run", icon: <FaPersonRunning /> },
  { name: "Bike", icon: <FaBicycle /> },
  { name: "Swim", icon: <FaPersonSwimming /> },
  { name: "Brick", icon: <FaLayerGroup /> },
  { name: "Crosstrain", icon: <FaWaveSquare /> },
  { name: "Day off", icon: <FaBed /> },
  { name: "Mtn Bike", icon: <FaMountain /> },
  { name: "Strength", icon: <FaDumbbell /> },
  { name: "Custom", icon: <FaClock /> },
  { name: "XC-Ski", icon: <FaPersonSkiing /> },
  { name: "Walk", icon: <FaPersonWalking /> },
  { name: "Other", icon: <FaQuestion /> },
  { name: "Note", icon: <FaNoteSticky /> },
  { name: "Attachment", icon: <FaPaperclip /> },
  { name: "Event", icon: <FaCalendarDay /> },
]

export default activities
